import { useEffect, useRef } from 'react'

function useScrollReveal(options = {}) {
    const ref = useRef(null)

    useEffect(()=> {
        const element = ref.current
        if (!element) return 

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    element.classList.add('revealed')
                    observer.unobserve(element)
                }
            },
            { threshold: 0.15, ...options}
        )

        observer.observe(element)
        return () => observer.disconnect()
    }, [])

    return ref 
}

export default useScrollReveal

